import { render, staticRenderFns } from "./ViewB2bimg.vue?vue&type=template&id=3aae2652&scoped=true"
import script from "./ViewB2bimg.vue?vue&type=script&lang=js"
export * from "./ViewB2bimg.vue?vue&type=script&lang=js"
import style0 from "./ViewB2bimg.vue?vue&type=style&index=0&id=3aae2652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae2652",
  null
  
)

export default component.exports